module.exports = JSON.parse('{"Cancel":"取消","Reset to defaults":"返回默认","Save":"保存","User preferences":"用户偏好"}')